module.exports = __webpack_public_path__ + "img/组 3037.e16cb5de.png";